var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { accountActionsConfig } from '../../../helpers';
export var initialState = {
    config: accountActionsConfig,
    selectedAccountId: (_a = sessionStorage.getItem('selectedAccountId')) !== null && _a !== void 0 ? _a : '',
    handleClose: function () { return null; },
    triggerAnalyticsEvent: function () { return null; }
};
export var ConfigContext = createContext(initialState);
ConfigContext.displayName = 'CreditLimitIncreaseContext';
export var useCreditLimitIncreaseContext = function () {
    var value = useContext(ConfigContext);
    if (!value) {
        throw new Error('No config');
    }
    return value;
};
var ConfigContextProvider = function (_a) {
    var state = _a.state, children = _a.children;
    var updatedServicesState = useMemo(function () { return state; }, [state]);
    return (_jsx(ConfigContext.Provider, __assign({ value: updatedServicesState }, { children: children })));
};
export default ConfigContextProvider;
